import React from 'react'
import s from './PrettyJson.scss'
import { flow, lowerCase, capitalize, keys, orderBy } from 'lodash/fp'
import cn from 'classnames'

const fixCaps = flow(lowerCase, capitalize)
const orderKeys = flow(keys, orderBy([], ['asc']))

// const transformData =
export const PrettyJson = ({ data, title, className }) => (
  <div className={cn(s.outer, className)}>
    <div className={s.title}>{title}</div>
    {orderKeys(data).map(key => (
      <div className={s.row} key={key}>
        <div>{fixCaps(key)}:</div>
        <div>{JSON.stringify(data[key])}</div>
      </div>
    ))}
  </div>
)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/PrettyJson/PrettyJson.jsx